import { useEffect, useState } from "react";
import { initialCompanyData } from "../data/companyData";
import { UI_SECTIONS, showSection } from "../config/uiVisibility";
import CompanyProfileTab from "./company/CompanyProfileTab";
import TeamManagementTab from "./company/TeamManagementTab";
import BillingUsageTab from "./company/BillingUsageTab";

const allTabs = [
  { id: "profile", label: "Company Profile", visible: true },
  { id: "team", label: "Team Management", visible: true },
  {
    id: "billing",
    label: "Billing & Usage",
    visible: showSection(UI_SECTIONS.companySettings.billingUsage)
  }
];

const tabs = allTabs.filter((t) => t.visible);

function CompanyTabBar({ activeTab, onTabChange }) {
  return (
    <div className="px-8 pt-4 flex gap-0 border-b border-gray-200 bg-[#FCFCFC]">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onTabChange(t.id)}
          className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
            activeTab === t.id
              ? "text-blue-600 border-blue-600"
              : "text-gray-500 border-transparent hover:text-blue-600"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export default function CompanySettings() {
  const [activeTab, setActiveTab] = useState("profile");

  useEffect(() => {
    const visibleIds = tabs.map((t) => t.id);
    if (!visibleIds.includes(activeTab)) {
      setActiveTab(visibleIds[0] ?? "profile");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- tabs derived from UI_SECTIONS flags
  }, [activeTab]);

  const handleSave = (companyInfo) => {
    // TODO: API call to save company data
  };

  const handleCancel = () => {
    // TODO: Reset to original data
    window.location.reload(); // Temporary: will refetch data
  };

  const handleEditMember = (member) => {
    // TODO: Open edit modal for member
  };

  const handleEditRole = (role) => {
    // TODO: Open role edit modal
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-[#FCFCFC]">
      <div className="flex-1 overflow-auto">
        <CompanyTabBar activeTab={activeTab} onTabChange={setActiveTab} />

        <div className="px-8 py-7 max-w-[1200px]">
          {activeTab === "profile" && (
            <CompanyProfileTab onSave={handleSave} onCancel={handleCancel} />
          )}

          {activeTab === "team" && (
            <TeamManagementTab
              roles={initialCompanyData.roles}
              showRolesSection={showSection(
                UI_SECTIONS.companySettings.teamRolesPermissions
              )}
              onEditMember={handleEditMember}
              onEditRole={handleEditRole}
            />
          )}

          {activeTab === "billing" &&
          showSection(UI_SECTIONS.companySettings.billingUsage) ? (
            <BillingUsageTab billing={initialCompanyData.billing} />
          ) : null}
        </div>
      </div>
    </div>
  );
}
